import { Queue } from '@rossum/api-client/queues';

export const isGenericEngine = (queue: Queue) => {
  // if Engine is set using the "modern way"
  if (queue.dedicatedEngine || queue.genericEngine) {
    return queue.dedicatedEngine === null && queue.genericEngine !== null;
  }

  // fallback to legacy way
  return !!queue.rirUrl && queue.rirUrl.startsWith('https://all.rir.');
};

export const isAuroraEngine = (queue: Queue) => !!queue.engine;

export const isSplitBatchFilesEnabled = (queue: Queue) => {
  return isGenericEngine(queue) || isAuroraEngine(queue);
};

export const getValidDocumentLifetime = (documentLifetime: string | null) => {
  if (documentLifetime) {
    const [days] = documentLifetime.split(' ');
    return days ?? null;
  }

  return null;
};

const DOC_LIFETIME_HOURS = '00:00:00';

export const setValidDocumentLifetime = (
  documentLifetime: string | null | undefined
) => {
  return documentLifetime === '' || documentLifetime === '0'
    ? null
    : `${documentLifetime} ${DOC_LIFETIME_HOURS}`;
};
